var map = {
	"./Commerce.png": 79166,
	"./Commerce.webp": 17938,
	"./Desarrollo Personal.png": 88694,
	"./Desarrollo Personal.webp": 57324,
	"./Diseño.png": 96702,
	"./Diseño.webp": 41142,
	"./Home Office.png": 13916,
	"./Home Office.webp": 49578,
	"./Idiomas.png": 89851,
	"./Idiomas.webp": 6243,
	"./Informática.png": 87046,
	"./Informática.webp": 5048,
	"./Inteligencia de Ventas.png": 47963,
	"./Inteligencia de Ventas.webp": 69297,
	"./Ofimatica.png": 88600,
	"./Ofimatica.webp": 68350,
	"./Programación.png": 88181,
	"./Programación.webp": 18099,
	"./miRutaAprendizaje.png": 81960,
	"./miRutaAprendizaje.webp": 62646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7583;